import { useTranslate } from '@gameday/utils/hooks/useTranslate';
 
const getInningTranslations = () => {
  let inningTranslations = {};
  const translate = useTranslate();
  for(let i = 1; i < 28; i++) {
    inningTranslations[i] = translate(`ranking_${i}`, i);
  }
  return inningTranslations;
}

export default getInningTranslations;
